var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "input-group" },
        [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c(
              "div",
              { staticClass: "input-group-text" },
              [_c("ItpIcon", { attrs: { icon: "mingcute:coin-line" } })],
              1
            )
          ]),
          _vm._v(" "),
          _vm.loaded
            ? _c("ItpFormSelect", {
                attrs: {
                  name: "billing_currency",
                  options: _vm.options,
                  valueField: "value",
                  textField: "value",
                  required: "",
                  readonly: _vm.readonly
                },
                on: {
                  input: function($event) {
                    return _vm.evh_5962862420439144_input($event, {})
                  }
                },
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }